// @ts-nocheck e1686e07

export default {
  SET_IS_REPEATER_STATE_ALLOWED: 'SET_IS_REPEATER_STATE_ALLOWED',
};
